/**
 * @fileoverview Model representing a Google Business Profile Configuration.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */
export class GbpConfiguration {
  /**
   * @param {{
   *  entityId: number,
   *  externalId: string,
   *  linkedAccountId: number,
   *  groupId: string,
   *  isVerified: boolean,
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.entityId = params.entityId;
    /** @type {string} */
    this.externalId = params.externalId;
    /** @type {number} */
    this.linkedAccountId = params.linkedAccountId;
    /** @type {string} */
    this.groupId = params.groupId;
    /** @type {boolean} */
    this.isVerified = params.isVerified;
  }

  /**
   * @override
   * @return {!GbpConfigurationJson} json
   */
  toJSON() {
    return {
      'entityId': this.entityId,
      'externalId': this.externalId,
      'linkedAccountId': this.linkedAccountId,
      'groupId': this.groupId,
      'isVerified': this.isVerified,
    };
  }

  /**
   * @param {!GbpConfigurationJson} json
   * @return {!GbpConfiguration}
   */
  static fromJSON(json) {
    return new GbpConfiguration({
      entityId: json['entityId'],
      externalId: json['externalId'],
      linkedAccountId: json['linkedAccountId'],
      groupId: json['groupId'],
      isVerified: json['isVerified'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  entityId: number,
 *  externalId: string,
 *  linkedAccountId: number,
 *  groupId: string,
 *  isVerified: boolean,
 * }}
 */
export var GbpConfigurationJson;
